import React, { Component } from "react";
import { connect } from 'react-redux';
import { checkPermission } from "@/utils/permission";
import { BellOutlined, ContainerOutlined, CustomerServiceOutlined, DeleteOutlined, DownOutlined, MenuOutlined } from "@ant-design/icons";
import { Dropdown, Modal, Space } from "antd";
import AppointmentForm from '@/components/appointments/AppointmentForm';
import CustomerCareForm from "@/components/customers/CustomerCareForm";
import { deleteCustomers } from "@/redux/actions/customerActions";
import CustomerServiceForm from "@/components/customer-services/CustomerServiceForm";

const { confirm } = Modal;

class DropdownActions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentData: null,
            isOpenAddServiceForm: false,
            isOpenAppointmentForm: false,
            isOpenCustomerCareForm: false
        }
    }

    openServiceForm(record, option) {
        this.setState({ isOpenAddServiceForm: true, currentData: record });
    }

    openScheduleForm(record) {
        this.setState({ isOpenAppointmentForm: true, currentData: record });
    }

    openCustomerCareForm(record) {
        this.setState({
            isOpenCustomerCareForm: true,
            currentData: record
        });
    }

    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá khách hàng này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.deleteCustomers([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
                this.props.loadData();
            }),
            onCancel() { },
        })
    }

    render() {

        const {
            currentData,
            isOpenAddServiceForm,
            isOpenAppointmentForm,
            isOpenCustomerCareForm
        } = this.state;

        const renderItems = () => {
            const itemsAction = [];
            const { record } = this.props;

            if (checkPermission('appointment', 'create')) {
                itemsAction.push(
                    {
                        key: '3',
                        label: (
                            <div onClick={() => this.openScheduleForm(record)}>Lịch hẹn</div>
                        ),
                        icon: <BellOutlined />
                    },
                )
            }
            if (checkPermission('customer_services', 'create')) {
                itemsAction.push(
                    {
                        key: '5',
                        label: (
                            <div onClick={() => this.openServiceForm(record, 'chot')}>Dịch vụ chốt</div>
                        ),
                        icon: <ContainerOutlined />
                    },
                )
            }
            if (checkPermission("customer_care_logs", "create")) {
                itemsAction.push(
                    {
                        key: '8',
                        label: (
                            <div onClick={() => this.openCustomerCareForm(record)}>Trả kết quả CSKH </div>
                        ),
                        icon: <CustomerServiceOutlined />
                    },
                )
            }
            if (checkPermission('customer', 'remove')) {
                itemsAction.push(
                    {
                        key: '9',
                        label: (
                            <div onClick={() => this.openAlert(record.id)}>Xóa khách hàng</div>
                        ),
                        icon: <DeleteOutlined />,
                        danger: true
                    }
                )
            }

            Object.keys(itemsAction).sort();
            return itemsAction;
        }

        const items = renderItems();

        return (
            <>
                <Space size="middle">
                    {items && items.length > 0 ? (
                        <Dropdown trigger="click" menu={{ items }}>
                            <div className='item-action-btn'>
                                <MenuOutlined /> <DownOutlined />
                            </div>
                        </Dropdown>
                    ) : (
                        <MenuOutlined style={{ color: '#dedede' }} />
                    )}
                </Space>

                <CustomerServiceForm
                    visible={isOpenAddServiceForm}
                    customerId={Number(currentData?.id)}
                    currentData={null}
                    reloadData={() => { }}
                    onCancel={() => this.setState({ isOpenAddServiceForm: false })}
                />
                <AppointmentForm
                    visible={isOpenAppointmentForm}
                    customerId={currentData?.id}
                    reloadData={() => false}
                    onCancel={() => this.setState({ isOpenAppointmentForm: false })}
                />

                <CustomerCareForm
                    visible={isOpenCustomerCareForm}
                    customerId={currentData?.id}
                    reloadData={() => this.props.loadData()}
                    editingItem={null}
                    onCancel={() => this.setState({ isOpenCustomerCareForm: false })}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        deleteCustomers: (ids) => dispatch(deleteCustomers(ids)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DropdownActions);